module.exports = __webpack_public_path__ + "assets/img/hh.91562580.png";